module.exports = __webpack_public_path__ + "2a57b6e46261c3c272e8d8727078a4a0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-12.png
// module id = 2246
// module chunks = 0